import wrapper from 'wrapper';

let touchstartX = 0;
let touchstartY = 0;

const { textDirection, includeName } = wrapper.getConfig();

const handleGesture = (touchendX, touchendY) => {
    const delx = touchendX - touchstartX;
    const dely = touchendY - touchstartY;
    if (Math.abs(delx) > Math.abs(dely)) {
        if (delx > 0) return 'right';
        return 'left';
    }
    if (Math.abs(delx) < Math.abs(dely)) {
        if (dely > 0) return 'down';
        return 'up';
    }
    return 'tap';
};

class Carousel {
    constructor() {
        this.component = wrapper.select(`.carousel__wrapper--${includeName} .carousel__component`);
        this.container = wrapper.select(`.carousel__wrapper--${includeName} .carousel__container`);
        this.content = wrapper.select(`.carousel__wrapper--${includeName} .carousel__content`);
        this.slides = wrapper.selectAll(`.carousel__wrapper--${includeName} .carousel__slide`);
        this.progress = wrapper.select(`.carousel__wrapper--${includeName} .carousel__progress-marker`);
        this.buttons = {
            next: wrapper.select(`.carousel__wrapper--${includeName} .carousel__button--next`),
            prev: wrapper.select(`.carousel__wrapper--${includeName} .carousel__button--prev`),
        };
        this.timeouts = {};

        this.progressWidth = 0;

        this.slideWidth = this.slides[0].offsetWidth;
        this.currentSlide = 0;

        this.setupProgressBar();
        this.setupEvents();
        this.update();
    }

    setupProgressBar() {
        this.progressWidth = 100 / this.slides.length;
        this.progress.style.width = `${this.progressWidth}%`;
    }

    setupEvents() {
        this.buttons.prev.addEventListener('click', (e) => {
            e.preventDefault();
            wrapper.trackClick(`${includeName}-click-previous-button`);
            this.prevSlide();
        });
        this.buttons.next.addEventListener('click', (e) => {
            e.preventDefault();
            wrapper.trackClick(`${includeName}-click-next-button`);
            this.nextSlide();
        });

        this.container.addEventListener('touchstart', (event) => {
            touchstartX = event.changedTouches[0].screenX;
            touchstartY = event.changedTouches[0].screenY;
        }, false);

        this.container.addEventListener('touchend', (event) => {
            const touchendX = event.changedTouches[0].screenX;
            const touchendY = event.changedTouches[0].screenY;

            const type = handleGesture(touchendX, touchendY);

            if (type === 'right') {
                wrapper.trackClick(`${includeName}-swipe-right-${textDirection}`);
                this.swipeRight();
            }

            if (type === 'left') {
                wrapper.trackClick(`${includeName}-swipe-left-${textDirection}`);
                this.swipeLeft();
            }
            if (type === 'tap') {
                if (event.changedTouches[0].clientX < window.innerWidth / 2) {
                    wrapper.trackClick(`${includeName}-tap-right-${textDirection}`);
                    event.preventDefault();
                    this.swipeRight();
                }
                else {
                    wrapper.trackClick(`${includeName}-tap-left-${textDirection}`);
                    event.preventDefault();
                    this.swipeLeft();
                }
            }
        }, false);
    }

    swipeLeft() {
        if (textDirection === 'rtl') this.prevSlide();
        else this.nextSlide();
    }

    swipeRight() {
        if (textDirection === 'rtl') this.nextSlide();
        else this.prevSlide();
    }

    nextSlide() {
        if (this.currentSlide < this.slides.length - 1) {
            this.currentSlide += 1;
        }
        else {
            this.currentSlide = 0;
        }

        this.highlight('next');
        this.update();
    }

    prevSlide() {
        if (this.currentSlide > 0) {
            this.currentSlide -= 1;
        }
        else {
            this.currentSlide = this.slides.length - 1;
        }

        this.highlight('prev');
        this.update();
    }

    update() {
        this.component.dataset.slide = this.currentSlide;

        const contentOffset = this.currentSlide * 100;
        const progressOffset = this.currentSlide * (100 / this.slides.length);

        const rtlWidth = 100 - this.progressWidth;
        const contentLeft = textDirection === 'rtl' ? contentOffset : 0 - contentOffset;
        const progressLeft = textDirection === 'rtl' ? rtlWidth - progressOffset : progressOffset;

        this.content.style.left = `${contentLeft}%`;
        this.progress.style.left = `${progressLeft}%`;

        wrapper.trackUserAction(`${includeName}-show-slide`, `${this.currentSlide}`);
    }

    highlight(id) {
        if (this.timeouts[id]) {
            window.clearTimeout(this.timeouts[id]);
        }
        const element = this.buttons[id];
        element.classList.add('active');
        this.timeouts[id] = window.setTimeout(() => element.classList.remove('active'), 300);
    }
}

export default Carousel;
